import React from 'react';
import { Popover, PopoverBody, PopoverHeader } from "reactstrap";
import MaterialIcon from "shared/react_components/MaterialIcon";

export default class CustomDataHelp extends React.Component {
  state = { open: false };
  helpRef = React.createRef();

  togglePopover = () => {
    this.setState({
      open: !this.state.open
    });
  }

  render() {
    const { open } = this.state;

    return (
      <span data-label="custom-data-label">
        Move Marketing Data associated with this Promo Number&nbsp;
        <MaterialIcon ref={this.helpRef} name="help" className="icon--help" onMouseEnter={this.togglePopover} onMouseLeave={this.togglePopover} />
        <Popover placement="top" isOpen={open} target={this.helpRef} toggle={this.togglePopover}>
          <PopoverHeader>When would I want to move Marketing Data?</PopoverHeader>
          <PopoverBody>
            Enable this checkbox if you would like the same attribution captured for this number when it is being used for a different campaign
          </PopoverBody>
        </Popover>
      </span>
    );
  }
}
